// src/components/User/Components/UserDataGrid/UserActionCell.js
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useGridApiContext } from "@mui/x-data-grid-pro";

const UserActionCell = ({ row, onEditUser }) => {
  const apiRef = useGridApiContext();

  const handleEdit = () => {
    onEditUser(row);
  };

  return (
    <Tooltip title="Edit User">
      <IconButton 
        onClick={handleEdit} 
        size="small"
        sx={{
          color: (theme) => theme.palette.text.secondary,
          "&:hover": {
            backgroundColor: (theme) => theme.palette.action.hover,
            color: (theme) => theme.palette.primary.main,
          },
        }}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default UserActionCell;
